import { useSecurity } from '../Contexts/SecurityContext';

/** Derives read-only UI state from the existing session; does not cache permission lists. */
export const useReadOnly = code => {
    const { canExecute } = useSecurity();
    return !canExecute(code);
};
